import toast from "react-hot-toast";
import { log, supabase } from ".";
import { generaComision } from "../constants/estadosEdificio";
import { EDIFICIOS_EXCLUIDOS } from "../constants/permisos";

export const getEdificiosOperativos = async ({ pais }) => {
  try {
    // Asumiendo que supabase.select es la forma correcta de hacer la consulta en tu configuración
    const data = await supabase.select("edificios", {
      filters: {
        pais,
      },
      orderBy: "pantallas",
      ascending: false,
    });

    // Filtrar por estado que genera comisión (OPERATIVO) — fuente única estadosEdificio.
    // Solo vivos (eliminada=false). Excluir EDIFICIOS_EXCLUIDOS (parche, ver Bloque E).
    const filteredData = data.filter(
      (edificio) => generaComision(edificio.estado) && !edificio.eliminada && !EDIFICIOS_EXCLUIDOS.includes(edificio.id)
    );

    if (filteredData.length === 0) {
      toast.error("No hay edificios cargados en la base de datos");
      throw new Error("No data found");
    }

    return filteredData;
  } catch (error) {
    log.error("getEdificiosOperativos", error);
    throw error;
  }
};
